export const SYNC_SCENES_LIST_CHANNEL = '@@scenes/scenesListChannelSync'
export const SYNC_SCENES_LIST_CHANNEL_SENT = '@@scenes/scenesListChannelSyncSent'
export const SYNC_SCENES_LIST_CHANNEL_CANCEL = '@@scenes/scenesListChannelSyncCancel'
export const OPEN_SCENES_LIST_CHANNEL = '@@scenes/scenesListChannelOpen'
export const CLOSE_SCENES_LIST_CHANNEL = '@@scenes/scenesListChannelClose'
export const SUBSCRIBE_SCENES_LIST_CHANNEL = '@@scenes/subscribeScenesListChannel'
export const UNSUBSCRIBE_SCENES_LIST_CHANNEL = '@@scenes/unsubscribeScenesListChannel'
